import Button from '../ui/Button'
import type { FunnelStage } from '../../lib/blog/types'

/** Conversion CTA whose copy varies by funnel stage. Links into the app. */
export default function CtaBlock({ funnelStage = 'MOFU' }: { funnelStage?: FunnelStage }) {
  const copy =
    funnelStage === 'BOFU'
      ? {
          heading: 'Convert your bank statement now',
          body: 'Upload a PDF statement and export clean transactions to Excel or CSV.',
          cta: 'Start free',
          to: '/sign-up',
        }
      : funnelStage === 'TOFU'
        ? {
            heading: 'See how automated extraction works',
            body: 'BankStatementReader turns PDF statements into structured Excel, CSV, or JSON.',
            cta: 'See how it works',
            to: '/',
          }
        : {
            heading: 'Skip the manual data entry',
            body: 'Try the free converter and export your statement to a spreadsheet in seconds.',
            cta: 'Try the free converter',
            to: '/tools/bank-statement-converter',
          }

  return (
    <aside className="mt-12 rounded-3xl bg-[#0f1320] text-surface px-8 py-8 flex flex-col gap-3">
      <h2 className="text-2xl font-bold m-0">{copy.heading}</h2>
      <p className="text-[rgba(228,233,245,0.85)] m-0">{copy.body}</p>
      <div className="mt-2">
        <Button to={copy.to}>{copy.cta}</Button>
      </div>
    </aside>
  )
}
